import { useTranslation } from 'react-i18next';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import { RAISERS_EDGE_STAGED_ATTRIBUTES } from '@feathr/blackbox';
import type { ICrmConnectionControls } from '@feathr/extender/App/Settings/Account/CrmIntegrationPage/crmIntegrationPage.hooks';
import { useCrmConnectionControls } from '@feathr/extender/App/Settings/Account/CrmIntegrationPage/crmIntegrationPage.hooks';

import { isSubscriptionProvisioningError } from './RaisersEdgeIntegrationPageV2.utils';

export type IRaisersEdgeConnectionControls = ICrmConnectionControls;

/** Pause, resume and disconnect for the v2 page. */
export function useRaisersEdgeConnectionControls(
  integration: BlackbaudRaisersEdgeIntegration | undefined,
): IRaisersEdgeConnectionControls {
  const { t } = useTranslation();

  return useCrmConnectionControls(integration, {
    stagedAttributes: RAISERS_EDGE_STAGED_ATTRIBUTES,
    // Expected for a few minutes after a connect, so it is a warning, not a failure.
    getExpectedFailure: (error) =>
      isSubscriptionProvisioningError(error)
        ? t("Raiser's Edge is still setting up this connection. Try again in a few minutes.")
        : undefined,
    // Pausing or resuming changes the webhook subscriptions the mapping rows report on.
    onStateChanged: (model) => {
      const store = model.contactMappingStore;
      if (store.isFetched) {
        void store.refresh();
      }
    },
  });
}
